import type {NextPage} from 'next'
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {NavBarLanding} from "../components/navBars/NavBarLanding";
import {LandingView} from "../components/landing/LandingView";
import {AuthService} from "../services/authService";
import {useAppSelector} from "../app/hooks";
import {selectIsAuthenticatingSession} from "../redux/auth/authSlice";
import {LoadingSpinnerIcon} from "../components/icons";

const Landing: NextPage = () => {
  const isAuthenticatingSession = useAppSelector(selectIsAuthenticatingSession);

  if (isAuthenticatingSession && AuthService.isRefreshTokenValid()) {
    return <div className="flex flex-col h-screen items-center justify-center">
      <LoadingSpinnerIcon className="h-10 w-10 animate-spin text-fg-primary" />
    </div>
  }

  return <div className="flex flex-col overflow-x-hidden">
    <NavBarLanding />
    <LandingView/>
  </div>
}

export const getStaticProps = async ({ locale }: any) => ({
  props: {
    ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order']),
  },
})

export default Landing
